
/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { GET_ALL_PERMISSION, GET_PERMISSION } from "./types";

const permissionInitialState: {
  permission: any,
  permissions: any,
  error: any,
} = {
  permission: [],
  permissions: [],
  error: []
};

export const functionalReducer = (state = permissionInitialState, action: any) => {
  switch (action.type) {
    case GET_PERMISSION:
      return {
        ...state,
        permission: action.permission || [],
      };
    case GET_ALL_PERMISSION:
      return {
        ...state,
        permissions: action.permissions || [],
      };
    default:
      return state;
  }
};